import React from "react";
import {dayMonthYearAtTime, timeago} from "../../../../utils/dates";

class NodesOfflineGridTemplate {
  alert;

  constructor(alert) {
    this.alert = alert;
  }

  columns = [
    {
      Header: "Node",
      accessor: "node.uuid",
    },
    {
      Header: "Nome",
      accessor: "node.friendlyName",
    },
    {
      Header: "Data da conexão perdida",
      accessor: "node.nodeDetail.dateLastPing",
      Cell: row => row.original.node.nodeDetail.dateLastPing && <p title={dayMonthYearAtTime(row.original.node.nodeDetail.dateLastPing)}>{dayMonthYearAtTime(row.original.node.nodeDetail.dateLastPing)} - {timeago(
        row.original.node.nodeDetail.dateLastPing)}</p>,
    },
    {
      Header: "Data da conexão restabelecida ",
      accessor: "closeDate",
      Cell: row => row.original.closeDate && <p title={dayMonthYearAtTime(row.original.closeDate)}>{dayMonthYearAtTime(row.original.closeDate)} - {timeago(row.original.closeDate)}</p>,
    },
  ];
  endpoint = () => `alerts/v1/alerts-details/alerts/${this.alert.id}/NODE_OFFLINE`
}

export {NodesOfflineGridTemplate}


// WEBPACK FOOTER //
// ./src/pages/Alerts/CustomAlert/NodeOfflineAlert/NodesOfflineGridTemplate.js